import { DataWithPagination } from "services/api";
import { Pagination } from "services/search";
import { FleetVehicleExpenseRow, FleetVehicleExpenseSearchFormValues } from "services/api/fleet/vehicles/expenses/types";
import { NoResults } from "ui/components/NoResults";

import VehicleExpenseSearchFilters from "./components/VehicleExpenseSearchFilters/VehicleExpenseSearchFilters";
import VehicleExpenseSearchResults from "./components/VehicleExpenseSearchResults/VehicleExpenseSearchResults";

interface VehicleExpenseSearchProps {
    isLoading: boolean;
    searchResults: DataWithPagination<FleetVehicleExpenseRow>;
    selectedRows: number[];
    onAddNew: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onSearchChange: (formValues: FleetVehicleExpenseSearchFormValues) => void;
    onRowClick: (id: string) => void | Promise<void>;
    onPaginationChange: (pagination: Pagination) => void;
    onSelectedChange: (id: number | number[]) => void;
    onDeleteClick: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>, id: string) => void;
}

const VehicleExpenseSearch: React.FC<VehicleExpenseSearchProps> = ({
    isLoading,
    searchResults,
    selectedRows,
    onAddNew,
    onSearchChange,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick,
}) => {
    return (
        <>
          <div className="px-0 py-6 mx-[-1px] mt-[-1px] xl:px-6 border ">
            <VehicleExpenseSearchFilters
                onAddNew={onAddNew}
                onSearchChange={onSearchChange}
            />
            {!isLoading && searchResults.pagination.totalPages === 0 ? (
                <NoResults message="Unesite vozilo klikom na 'Dodaj trošak'" />
            ) : (
                <VehicleExpenseSearchResults
                    searchResults={searchResults}
                    selectedRows={selectedRows}
                    isLoading={isLoading}
                    onRowClick={onRowClick}
                    onPaginationChange={onPaginationChange}
                    onSelectedChange={onSelectedChange}
                    onDeleteClick={onDeleteClick}
                />
            )}
            </div>
        </>
    );
};

export default VehicleExpenseSearch;
